import { render, staticRenderFns } from "./RippleList.vue?vue&type=template&id=15f468d9&scoped=true"
import script from "./RippleList.vue?vue&type=script&lang=js"
export * from "./RippleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f468d9",
  null
  
)

export default component.exports